import { render, staticRenderFns } from "./RequestedAssetMetadataInfo.vue?vue&type=template&id=130ac476&scoped=true"
import script from "./RequestedAssetMetadataInfo.vue?vue&type=script&lang=js"
export * from "./RequestedAssetMetadataInfo.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RequestedAssetMetadataInfo.vue?vue&type=style&index=1&id=130ac476&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130ac476",
  null
  
)

export default component.exports